// Dependency-free enum of every sidebar entry, split out of sidebar.tsx (which
// drags React + MUI + reducers) so pure logic — e.g. the active-item resolver —
// and its unit tests can import it without pulling the whole component tree.
//
// sidebar.tsx re-exports this so existing `import { SideBarItem } from
// "@common-components/sidebar/sidebar"` call sites keep working unchanged.
export enum SideBarItem {
  AccountSettings,
  Language,
  Notifications,
  Security,
  Backup,
  Workspace,
  AdminWorkspace,
  AccountUsers,
  AdminBilling,
  UserManagement,
  AdminAPI,
  Subscriptions,
  Invoices,
  Devices,
  Calendar,
  Campaigns,
  Audiences,
  Drips,
  Tasks,
  LaunchCampaign,
  CampaignsManagement,
  Agents,
  KnowledgeBase,
  CreditsUsage,
  WhatsAppNumbers,
  Support,
  TeamInbox,
  WhatsAppConnections,
  MyBridge,
  Refer,
}
